function TrainHealthGridletController(
  ConditionService,
  fleetService,
  $rootScope,
  eventService,
) {
  const ctrl = this;

  ctrl.$onInit = () => {
    loadTrainData();
  };

  const loadTrainData = async () => {
    ctrl.dataLoading = true;
    ctrl.trainsWithCars = await fleetService.getTrainsWithCars();
    ctrl.trains = ctrl.trainsWithCars.map(value => value.trainId);

    ctrl.selectedTrain = ctrl.trains[0];
    if (ctrl.trainsWithCars.length > 0){
      ctrl.processCarData(ctrl.selectedTrain);
    } 

    ctrl.dataLoading = false;
  };

  ctrl.processCarData = async (trainId) => {
    ctrl.noDataAvailable = false;
    const trainData = ctrl.trainsWithCars.find(train => {
      return train.trainId === trainId;
    });

    if (trainData.cars.length > 0) {
      ctrl.selectedTrain = trainId;
      const params = {
        carIds: trainData.cars
      };

      ctrl.carData = await ConditionService.getLatestForCars(params);

      ctrl.carData.forEach(car => {
        car.bogies.forEach(bogie => {
          bogie.categories.forEach(category => {
            car.lastDataTime = formatTime(car.lastDataTime);
            addStatusLevels(category.assets);
          });
        });
      });
    } else {
      ctrl.noDataAvailable = true;
    }
  };

  const formatTime = timestamp => {
    let time = DateTime.fromISO(timestamp)
      .toFormat('dd.MM.yyyy HH:mm:ss');

    if (time === 'Invalid DateTime') {
      time = '-';
    }
    return time;
  };

  const addStatusLevels = assets => {
    assets.forEach(asset => {
      if (asset.ci_values !== null) {
        asset.ci_values.forEach(ci => {
          ci.latestValue = _.last(ci.results).value;
        });
      }
    });
  };

  eventService.on('update-train-health', function () {
    loadTrainData();
  });

  ctrl.handleSubsystemType = (name, carNumber) => {
    if (name === 'bogie') {
      return {
        name: 'Bogie',
        cis: ctrl.currentData,
        carNumber: carNumber,
      };
    }
  };

  // Not used right now, ignore
  ctrl.checkSubsystemStatus = () => {
    _.each(ctrl.bogieCIS, item => {
      if (item.value > item.config.alarmThreshold) {
        $rootScope.$emit('carStatus', {
          car: 0,
          status: 'alarm',
          subsystem: 'bogieAlarm',
        });
      }
      if (item.value > item.config.warningThreshold) {
        $rootScope.$emit('carStatus', {
          car: 0,
          status: 'warning',
          subsystem: 'bogieWarning',
        });
      }
    });
  };
}

angular
  .module('dashboardGridletDirectives')
  .controller('TrainHealthGridletController', TrainHealthGridletController);
